module.exports = __webpack_public_path__ + "media/images/arrow@2x-c64d8c3d4d83ed8c267415b1f57abef3.png";